import AppConfigForm from './AppConfigForm';

export default AppConfigForm;
